<div class="main_content p-1 p-sm-2 p-md-3 position-relative">
  <div class="container-fluid">
    <div class="title mb-4">
      <h2>
        Update Profile
        <a class="back_btn" (click)="back()">Back</a>
      </h2>
    </div>
    <div class="profile bg-white">
      <div class="profile_body bg-white py-5">
        <div class="row justify-content-around">
          <div class="col-lg-3 col-md-12 col-sm-12">
            <div
              class="profile_img rounded-circle overflow-hidden ml-lg-auto mr-lg-0 mx-auto"
            >
              <img loading="lazy"
                src="../../../assets/images/new/blank-profile-picture.png"
                alt=""
                *ngIf="profile_pic_url_selected == 0 && user_image == ''"
              />
              <img loading="lazy"
                src="{{ imgUrl }}{{ user_image }}"
                alt=""
                *ngIf="profile_pic_url_selected == 0 && user_image != ''"
                class="profile_pic"
              />
              <img loading="lazy"
                src="{{ profile_pic_url }}"
                *ngIf="profile_pic_url_selected == 1"
                class="profile_pic"
              />
            </div>
            <div class="profile_uplode mt-4 text-lg-right text-center">
              <button
                type="button"
                class="hover_btn"
                (click)="fileInput.click()"
              >
                Upload photo
                <input
                  #fileInput
                  type="file"
                  #file
                  hidden
                  (change)="onImageSelected(file.files, $event)"
                />
              </button>
            </div>
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12">
            <div class="profile_info px-3">
              <h2>{{ company_name }}</h2>
              <a class="user_email text-decoration-none">{{ user_email }}</a>
              <form class="" [formGroup]="edit_profile">
                <label for="f-name" class="mt-5">First name</label> <br />
                <input
                  type="text"
                  formControlName="first_name"
                  class="form-control border-bottom"
                  placeholder="Enter first name"
                />
                <ng-container
                  *ngIf="submitted && edit_profile_v.first_name.errors"
                >
                  <p
                    class="error-message"
                    *ngIf="edit_profile_v.first_name.errors.required"
                  >
                    First name is required!
                  </p>
                </ng-container>

                <label for="l-name" class="mt-5">Last name</label> <br />
                <input
                  type="text"
                  formControlName="last_name"
                  class="form-control border-bottom"
                  placeholder="Enter last name"
                />
                <ng-container
                  *ngIf="submitted && edit_profile_v.last_name.errors"
                >
                  <p
                    class="error-message"
                    *ngIf="edit_profile_v.last_name.errors.required"
                  >
                    Last name is required!
                  </p>
                </ng-container>

                <label for="job" class="mt-5">Company Name</label> <br />
                <input
                  type="text"
                  class="form-control border-bottom"
                  formControlName="job_title"
                  placeholder="Enter job title"
                />
                <ng-container
                  *ngIf="submitted && edit_profile_v.job_title.errors"
                >
                  <p
                    class="error-message"
                    *ngIf="edit_profile_v.job_title.errors.required"
                  >
                    Job title is required!
                  </p>
                </ng-container>

                <label for="mobile" class="mt-5">Special ID</label> <br />
                <div class="mobile_no d-flex align-items-center border-bottom">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter special ID"
                    formControlName="phone_number"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                    pattern="[0-9]+"
                  />
                </div>
                <!-- <ng-container *ngIf="submitted && edit_profile_v.phone_number.errors">
                                    <p class="error-message"
                                        *ngIf=" edit_profile_v.phone_number.errors.required">
                                        Special ID is required!
                                    </p>
                                    <p class="error-message" *ngIf=" edit_profile_v.phone_number.errors.minlength">
                                        Special ID should be minimum of 7 numbers.
                                    </p>
                                </ng-container> -->
                <label for="wsapp" class="mt-5">WhatsApp number</label> <br />
                <div class="mobile_no d-flex align-items-center border-bottom">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter whatsapp mobile number"
                    formControlName="whatsapp_number"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                    pattern="[0-9]+"
                  />
                </div>
                <ng-container
                  *ngIf="submitted && edit_profile_v.whatsapp_number.errors"
                >
                  <p
                    class="error-message"
                    *ngIf="edit_profile_v.whatsapp_number.errors.required"
                  >
                    WhatsApp number is required!
                  </p>
                  <p
                    class="error-message"
                    *ngIf="edit_profile_v.whatsapp_number.errors.minlength"
                  >
                    Whatsapp number should be minimum of 7 numbers.
                  </p>
                </ng-container>
                <!-- <label for="telegram">Telegram user id</label> <br>
                                <div class="d-flex align-items-center border-bottom mb-4">
                                    <i class="fa-solid fa-at mr-2"></i> 
                                    <input type="text" class="form-control" placeholder="Enter telegram user id" formControlName="telegram_id">
                                    
                                </div>
                                <ng-container *ngIf="submitted && edit_profile_v.telegram_id.errors">
                                    <p class="error-message" *ngIf=" edit_profile_v.telegram_id.errors.required">
                                        Telegram user id is required!
                                    </p>
                                    </ng-container> -->
              </form>

              <div class="profile_buttons d-flex mt-5">
                <a
                  class="profile_btn hover_btn text-decoration-none mr-3"
                  (click)="update_profile()"
                  >Save profile</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
